<template>
  <div class="search-input">
    <div class="search-icon" @click="handleSearch"></div>
    <input 
      v-model="searchValue" 
      name="search"
      type="search" 
      :placeholder="placeholder" 
      class="review-search-bar"
      @keydown.enter.prevent="handleSearch"
      @search.prevent="handleSearch"
    >
  </div>
</template>

<script>
import { ref, watch } from 'vue';

export default {
  name: 'SearchInput',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue', 'search'],
  setup(props, { emit }) {
    const searchValue = ref(props.modelValue);

    watch(() => props.modelValue, (newValue) => {
      searchValue.value = newValue;
    });

    watch(searchValue, (newValue) => {
      emit('update:modelValue', newValue);
    });

    const handleSearch = (event) => {
      if (event) {
        event.preventDefault();
      }
      emit('search', searchValue.value);
    };

    return {
      searchValue,
      handleSearch
    };
  }
};
</script>